import {useInfiniteQuery} from "@tanstack/react-query";

import {ITEMS_PER_PAGE} from "@/src/modules/core/utils/constants";

import {patrolRoutesService} from "../services";

type Params = {filters?: Record<string, unknown>; sort?: string; enabled?: boolean};

export function useInfinitePatrolRoutes({filters = {}, sort = "name", enabled = true}: Params = {}) {
  const options = {filter: filters, sort};
  const {data, ...query} = useInfiniteQuery({
    queryKey: ["infinite-patrol-routes", options],
    enabled,
    queryFn: ({pageParam = 0}) =>
      patrolRoutesService.list({...options, page: {limit: ITEMS_PER_PAGE, offset: pageParam}}),
    getNextPageParam: (lastPage, pages) => {
      const loaded = pages.reduce((acc, p) => acc + (p.data?.length ?? 0), 0);
      return loaded < (lastPage.meta?.total ?? 0) ? loaded : undefined;
    },
    initialPageParam: 0,
  });
  return {
    routes: data?.pages.flatMap((p) => p.data ?? []) ?? [],
    totalRecords: data?.pages[0]?.meta?.total ?? 0,
    hasNextPage: query.hasNextPage ?? false,
    fetchNextPage: query.fetchNextPage,
    isFetching: query.isFetching,
    isFetchingNextPage: query.isFetchingNextPage,
    isPending: query.isPending,
    isSuccess: query.isSuccess,
    isError: query.isError,
    error: query.error,
  };
}
